import React, { memo, useContext, useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'

import styles from './styles.module.css'
import prize_180 from '../../../../images/prize_180.png'
import prize_180_kz from '../../../../images/prize_180_kz.png'
import prize_combined from '../../../../images/prize_combined.png'
import prize_balloons from '../../../../images/prize_balloons.png'
import gold_confetti from '../../../../images/gold_confetti.png'
import { LoginForm } from '../../../../components/LoginForm'
import { classNames } from '@monorepo/utils'
import ButtonLoader from '../../../../components/Button'
import { TabValue } from '../../../../constants'
import { useLogin } from '@monorepo/api'
import { ContextApp } from '@monorepo/service'

interface ModalProps {
  isOpenModal: number
  closeModal: () => void
  openReg: () => void
}

const Modal: React.FC<ModalProps> = ({ isOpenModal, openReg, closeModal }) => {
  const { t, i18n } = useTranslation()
  const { isCdaBalancerInfoLoading, cdaBalancerInfo } = useContext(ContextApp)
  const [activeTab, setActiveTab] = useState<TabValue>(TabValue.Phone)
  const openTimeRef = useRef<number | null>(null)
  const isProcessingRef = useRef<boolean>(false)

  const { redirectToLoginPage } = useLogin({
    geo: 'KZ',
    isBalancerInfoLoading: isCdaBalancerInfoLoading,
    balancerInfo: cdaBalancerInfo,
  })

  useEffect(() => {
    if (isOpenModal) {
      openTimeRef.current = Date.now()
      isProcessingRef.current = false
    }
  }, [isOpenModal])

  if (!isOpenModal) return null

  const handleClick = () => {
    if (isProcessingRef.current) return
    isProcessingRef.current = true

    if (isOpenModal === 3) {
      closeModal()
    } else if (isOpenModal === 2) {
      const now = Date.now()
      const elapsed = openTimeRef.current ? now - openTimeRef.current : 0
      const delay = Math.max(2000 - elapsed, 0)

      if (delay > 0) {
        setTimeout(() => {
          openReg()
        }, delay)
      } else {
        openReg()
      }
    }
  }

  return (
    <>
      {isOpenModal === 4 && (
        <>
          <div className={styles.backgroundImageFilter} />
        </>
      )}
      <div
        className={classNames(styles.modalMask, isOpenModal === 4 && styles.regMask)}
        onClick={handleClick}
      >
        {isOpenModal === 3 && (
          <>
            <img
              className={styles.prize}
              src={i18n.language === 'ru' ? prize_180 : prize_180_kz}
              alt="Prize 180 free spins"
            />
            <img className={styles.prize_balloons} src={prize_balloons} alt="Flying balloons" />
          </>
        )}
        {isOpenModal === 2 && (
          <>
            <img
              className={styles.prize_combined}
              src={prize_combined}
              alt="Prize 1500000T + 180 free spins"
            />
            <img className={styles.prize_balloons} src={prize_balloons} alt="Flying balloons" />
          </>
        )}
        {isOpenModal === 4 && (
          <>
            <img className={styles.goldConfetti1} src={gold_confetti} alt="Gold confetti" />
            <img className={styles.goldConfetti2} src={gold_confetti} alt="Gold confetti" />
            <img className={styles.goldConfetti3} src={gold_confetti} alt="Gold confetti" />
            <div className={styles.registerFormContainer}>
              <div className={styles.balloonsBack}></div>
              <div className={styles.radianCircle} />
              <div className={styles.balloonsFront}></div>
              <div
                className={classNames(
                  styles.modal,
                  activeTab === TabValue.Phone ? styles.modalPhoneBg : styles.modalEmailBg,
                )}
              >
                <div className={styles.bigText}>
                  <span>
                    {t('form.bonusUpTo')}
                    <span className={styles.goldText}>{t('form.win-line-1')}</span>
                  </span>
                  <span>
                    {t('form.toDeposit')}
                    <span className={styles.goldText}>{t('form.win-line-2')}</span>
                  </span>
                </div>
                <LoginForm activeTab={activeTab} setActiveTab={setActiveTab}>
                  <ButtonLoader className={styles.modalButton}>{t('form.button')} </ButtonLoader>
                </LoginForm>
                <div className={styles.enterContainer}>
                  <span>{t('form.hasAccount')}</span>
                  <a
                    className={isCdaBalancerInfoLoading ? styles.loading : undefined}
                    onClick={redirectToLoginPage}
                  >
                    {t('form.enter')}
                  </a>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  )
}

export default memo(Modal)
